import * as React from "react";
import { forwardRef } from "react";
const SvgArrowTopDownBox = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "currentColor",
	height: "1em",
	viewBox: "0 0 5 15",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M5 5L5 0L0 0L0 5H1.5L1.5 10L0 10L0 15L5 15L5 10H3.5L3.5 5H5Z" }));
const ForwardRef = forwardRef(SvgArrowTopDownBox);
export default ForwardRef;
